import React from "react";
import { NavLink } from "react-router-dom";

import { StyledFooterBlockItem, StyledFooterBlockItemList, StyledFooterBlockItemTitle } from "./styledFooter";

const FooterProduct = () => {
  return (
    <StyledFooterBlockItem>
      <StyledFooterBlockItemTitle>
        Product
      </StyledFooterBlockItemTitle>
      <StyledFooterBlockItemList>
        <li>
          <NavLink to="/tariff-and-subscription">
            Subscriptions
          </NavLink>
        </li>
        <li>
          <NavLink to="/card-verification">
            Card verification
          </NavLink>
        </li>
        <li>
          <NavLink
            to={{
              pathname: "/blog",
              state: { manualKey: "blog" }
            }}
          >
            Blog
          </NavLink>
        </li>
        <li>
          <NavLink  to={{
            pathname: "/help",
            state: { manualKey: "help" }
          }}>
            Help
          </NavLink>
        </li>
      </StyledFooterBlockItemList>
    </StyledFooterBlockItem>
  );
};

export default FooterProduct;